import { useState, useEffect, useCallback } from 'react';
import { supabase } from '../supabase';
import { staffNameFrom } from '../utils/assignments';

// Self-loading assignment data for components that don't already hold it (e.g. ParcelModal). Loads all
// client_role_assignments + active ntrg_staff + a clients.id→name map. StaffPortal already keeps this data
// in state, so it uses the pure helpers in utils/assignments directly rather than this hook.
//
// ⛔ THIS MAP USED TO RUN name→id (clientIdByName), because parcels carry a denormalised client_name and
// assignments key on clients.id. Its only consumer resolved a client by NAME, which meant id→name→id on a
// column that can be null — and is null on every parcel created through the app, since the create insert
// writes no client_id either. Callers now use client_id directly; the map runs id→name and exists to LABEL
// a client, never to find one.
export default function useAssignments() {
  const [assignments, setAssignments] = useState([]);
  const [staff, setStaff] = useState([]);
  const [clientNameById, setClientNameById] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    let alive = true;
    (async () => {
      const [asg, st, cl] = await Promise.all([
        supabase.from('client_role_assignments').select('*'),
        supabase.from('ntrg_staff').select('id,name').eq('active', true).order('name'),
        supabase.from('clients').select('id,name'),
      ]);
      if (!alive) return;
      setAssignments(asg.data || []);
      setStaff(st.data || []);
      const map = {};
      (cl.data || []).forEach(x => { if (x.id) map[x.id] = x.name; });
      setClientNameById(map);
      setLoading(false);
    })();
    return () => { alive = false; };
  }, []);

  const staffName = useCallback(id => staffNameFrom(staff, id), [staff]);
  return { assignments, staff, staffName, clientNameById, loading };
}
